<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Tipos de Habitación</h3>
        <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Tipo</button>
      </div>

      <!-- Formulario -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nuevo Tipo de Habitación</h5>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Nombre</label>
            <input v-model="nuevoTipo.Nombre" type="text" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label">Descripción</label>
            <input v-model="nuevoTipo.Descripcion" type="text" class="form-control" />
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarTipo">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="tipos.length === 0">
              <td colspan="3">No hay tipos de habitación registrados.</td>
            </tr>
            <tr v-for="tipo in tipos" :key="tipo.IdTipoHabitacion">
              <td>{{ tipo.Nombre }}</td>
              <td>{{ tipo.Descripcion }}</td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(tipo)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(tipo)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Actualizar -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Tipo</h5>
            <button type="button" class="btn-close" @click.stop="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Nombre</label>
                <input v-model="tipoEditar.Nombre" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Descripción</label>
                <input v-model="tipoEditar.Descripcion" type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarTipo">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar el tipo de habitación <strong>{{ tipoEliminar?.Nombre }}</strong>?</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "TipoHabitacionGestion",
  data() {
    return {
      tipos: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      tipoEditar: null,
      tipoEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevoTipo: {
        Nombre: "",
        Descripcion: "",
      },
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerTipos() {
      const res = await axios.get(`${API_URL}/tipohabitacion`);
      this.tipos = res.data;
    },
    async guardarTipo() {
      const { Nombre } = this.nuevoTipo;
      if (!Nombre) {
        this.mostrarAlerta("El nombre es obligatorio", "danger");
        return;
      }
      try {
        await axios.post(`${API_URL}/tipohabitacion`, this.nuevoTipo);
        this.mostrarAlerta("Tipo agregado", "success");
        this.nuevoTipo = { Nombre: "", Descripcion: "" };
        this.mostrarFormulario = false;
        this.obtenerTipos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar", "danger");
      }
    },
    abrirModal(tipo) {
      this.tipoEditar = { ...tipo };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.tipoEditar = null;
      this.mostrarModal = false;
    },
    async actualizarTipo() {
      try {
        await axios.put(`${API_URL}/tipohabitacion/${this.tipoEditar.IdTipoHabitacion}`, this.tipoEditar);
        this.mostrarAlerta("Tipo actualizado", "success");
        this.cerrarModal();
        this.obtenerTipos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(tipo) {
      this.tipoEliminar = { ...tipo };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.tipoEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async confirmarEliminar() {
      if (!this.tipoEliminar) return;
      try {
        await axios.delete(`${API_URL}/tipohabitacion/${this.tipoEliminar.IdTipoHabitacion}`);
        this.mostrarAlerta("Tipo eliminado", "success");
        this.obtenerTipos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevoTipo = { Nombre: "", Descripcion: "" };
    },
  },
  mounted() {
    this.obtenerTipos();
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 600px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
